import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function LoginView() {
  const [correo, setCorreo] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  
  //  Usamos la función centralizada 'login' en lugar de 'setUser'
  const { login } = useContext(AuthContext); 
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (!correo || !contrasena) {
        setError('Por favor completa todos los campos');
        return;
      }

     // CAMBIO: Apuntamos directamente al dominio real en cPanel con https
     const response = await fetch('https://clavelinacarnes.com/clavelina-backend-php/src/Routes/admin/login.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ correo, contrasena })
    });
    const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Error al iniciar sesión');
        return;
      }

      //  Preparamos el objeto con la estructura limpia
      const usuarioParaContexto = {
        token: data.token,
        id: data.usuario.id,
        nombre: data.usuario.nombre,
        rol: data.usuario.rol
      };

      //  VALIDACIÓN DE SEGURIDAD: Evitamos que un delivery entre al panel admin
      if (usuarioParaContexto.rol !== 'admin') {
        setError('Acceso denegado: Esta área es solo para administradores');
        return;
      }

      //  LLAMADA CENTRALIZADA: 
      // Esta función hace el localStorage.setItem y el setUser al mismo tiempo.
      login(usuarioParaContexto);

      //  NAVEGACIÓN DIRECTA: Ya no hace falta el delay de 150ms
      navigate('/admin');

    } catch (err) {
      console.error("Error en login:", err);
      setError('Error de conexión con el servidor');
    }
  };

  return (
    <div className="intro-box">
      <h2 className="intro-title" style={{ color: '#fff', textAlign: 'center' }}>Clavelina-Admin</h2>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Correo"
          value={correo}
          onChange={(e) => setCorreo(e.target.value)}
          required
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={contrasena}
          onChange={(e) => setContrasena(e.target.value)}
          required
          style={inputStyle}
        />
        <button type="submit" style={buttonStyle}>Ingresar</button>
      </form>
      {error && <p style={{ color: '#ff4d4d', marginTop: '15px', textAlign: 'center' }}>{error}</p>}
    </div>
  );
}

const inputStyle = { width: '100%', padding: '12px', marginBottom: '15px', borderRadius: '4px', border: '1px solid #444', backgroundColor: '#222', color: '#fff' };
const buttonStyle = { width: '100%', padding: '12px', backgroundColor: '#ff0000', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' };

export default LoginView;